import React from "react";
import { ArrowUpRight, Clock3, MapPin } from "lucide-react";

function ContactSection({ setReserveOpen }) {
  return (
    <section id="contact" className="contact section">
      <div className="contact-main">
        <p className="kicker">FIND YOUR WAY TO JALSA</p>
        <h2>Let's make<br /><i>tonight count.</i></h2>
        <div className="contact-details">
          <div><MapPin size={19} /><span>Whitefield, Bengaluru<br /><small>Karnataka, India</small></span></div>
          <div><Clock3 size={19} /><span>Open daily<br /><small>12:00 PM — 1:00 AM</small></span></div>
        </div>
        <button className="gold-btn" onClick={() => setReserveOpen(true)}>Reserve a table <ArrowUpRight size={18} /></button>
      </div>
      <div className="contact-card">
        <div className="map-placeholder">
          <div className="map-rings" />
          <MapPin size={32} />
          <span>JALSA<br />WHITEFIELD</span>
        </div>
        <div className="contact-card-bottom">
          <span>Need a larger celebration?</span>
          <button>Plan an event <ArrowUpRight size={16} /></button>
        </div>
      </div>
    </section>
  );
}

export default ContactSection;
